import { useSupabaseLoader } from "../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../server/supabase/hooks/types";
import type { UUID } from "../../../utils/uuid";
import type { AdminAccountLimit } from "../../generic/server/supabase-account-service";
import { CeAdminSupabaseAccountService } from "../../generic/server/supabase-account-service";

export const useAccountDetail = (
  accountId: UUID | undefined,
): UseSupabaseLoaderState<AdminAccountLimit | null> & { reload: () => void } =>
  useSupabaseLoader<AdminAccountLimit | null, "ce_admin">(
    async ({ supabase }) => {
      if (!accountId) throw new Error("No account id");
      const { data, error } = await new CeAdminSupabaseAccountService(supabase).getAccountLimit(
        accountId,
      );
      if (error) throw new Error("Could not load account");
      return data;
    },
    [accountId],
    "ce_admin",
  );
